export default __webpack_public_path__ + "static/media/logo_bdspack.9bb3586a.png";